import { Component, Input } from '@angular/core';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { PageId } from './select-form-modal.types';
import { ToastrService } from 'ngx-toastr';




@Component({
  selector: 'app-select-forum-modal',
  templateUrl: './select-forum-modal.component.html',
  styleUrl: './select-forum-modal.component.scss'
})

export class SelectForumModalComponent {
  @Input()
  public type : 'product';

  @Input()
  public  set pageId(value : PageId){
    this._pageId = value;
    this.refreshView()
  }

  public allForumsList = [];
  public linkedForum: Set<any> = new Set()

  constructor(private auth: AuthServiceService, private toastr: ToastrService){}
  
  public searchKeyword = ''
  public refreshView(){
    this.auth.marketplace_forum_shop_fetch(
      undefined, 1, '', [], false, this.searchKeyword, 3
    ).subscribe(
      {
        error: err =>{
          console.error(err);
          this.toastr.error("Something went wrong while fetching forums")
        },
        next: (data: any) =>{
          this.allForumsList = data.body.data;
        }
      }
    )

    this.auth.getPagesLinkToForums(this.type, this._pageId)
    .subscribe(
      {
        next: data =>{
          for(const selected of data.body){
            this.linkedForum.add(selected.forumId)
          }
        },
        error: console.error
      }
    )

  

  }

  public toggleForumLink(forum){
    this.auth.toggleLinkForumToPage(this.type, this._pageId, forum.id)
    .subscribe({
      next: ()=>{
        if(this.linkedForum.has(forum.id)){
          this.linkedForum.delete(forum.id);
        }else{
          this.linkedForum.add(forum.id)
        }
        this.toastr.success("Changed successfully!")
      },
      error: err=>{
        console.error(err);
        this.toastr.error("Error something wrong when trying to toggle page forum link")
      }
    })

  }

  public get proudId() : PageId{
    return this._pageId;
  }


  private  _pageId? : PageId;




}
